module.exports = __webpack_public_path__ + "static/media/sailor.a87cebea.jpg";